<template>
    <h1 class="h3 mb-3">
        <strong>Page</strong>  Not Found
    </h1>
</template>

<script>
export default {
    name: 'NotFound',
    components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
